import { makeStyles } from "@material-ui/core";
import { white, backgroundColor, bordo, blue } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down, up } }) => ({
  header: {
    height: "300px",
    background: backgroundColor,
    borderTopRightRadius: "50px",
    borderTopLeftRadius: "50px",
  },
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "30px",
    [down("xs")]: {
      padding: "17px 23px",
    },
  },
  navLink: {
    fontFamily: "sbcRegular",
    fontSize: "14px",
    color: white,
    lineHeight: 1.5,
    fontWeight: "normal",
    margin: "0 2.5rem",
    position: "relative",
    transition: "all 0.3s ease",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  logoLink: {
    width: "20%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  /// Menu
  icon: {
    "& svg": { width: 24 },
  },
  close: {
    "&.MuiIconButton-root:hover": {
      backgroundColor: "rgb(244 246 247 / 20%)",
    },
    [down("sm")]: {
      width: "45px",
      height: "45px",
      backgroundColor: "rgb(244 246 247 / 20%)",
      borderRadius: "39px",
      zIndex: 1000,
      position: "absolute",
      left: "10%",
      top: "5%",
    },
    [down("xs")]: {
      left: "15%",
      top: "5%",
    },
  },
  shadow: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    zIndex: 100,
    backgroundColor: "rgb(0 0 0 / 70%)",
    transition: "all 0.5s ease",
  },
  menu: {
    width: "100%",
    zIndex: 2,
    // display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFF",
    height: "100%",
    padding: "26px 18px 47px",
    boxSizing: "border-box",
    boxShadow:
      "0px 32px 52px rgba(0, 0, 0, 0.07), 0px 16px 76px rgba(0, 0, 0, 0.07)",
    [down("sm")]: {
      maxHeight: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      padding: "20%",
      backgroundColor: "#282F36",
      width: "95%",
      borderTopLeftRadius: "90px",
      borderBottomLeftRadius: "90px",
      "& a": {
        color: white,
        fontFamily: "sbcBold",
        fontSize: "2.5rem",
        paddingBottom: "20px",
        "&:first-of-type": {
          color: "rgb(255 255 255 / 50%)",
        },
        "@media (max-width: 350px)": {
          fontSize: "2rem",
          paddingBottom: "15px",
        },
      },
    },
  },
  menuContainer: {
    position: "fixed",
    display: "flex",
    top: 0,
    right: 0,

    height: "100vh",
    zIndex: 2,
    [down("sm")]: {
      "& a": {
        fontSize: "2.3rem",
        "@media (max-width: 350px)": {
          fontSize: "2rem",
        },
      },
    },
  },
  menuClose: {
    [down("sm")]: {
      right: "-100%",
      width: "100%",
      // left: 0,
      overflow: "hidden",
      zIndex: 999,
      left: "auto",
      display: "flex",
      justifyContent: "flex-end",
      transition: "right 1s",
    },
  },
  menuOpen: {
    [down("sm")]: {
      width: "100%",
      // left: 0,
      overflow: "hidden",
      zIndex: 999,
      right: 0,
      left: "auto",
      display: "flex",
      justifyContent: "flex-end",
      transition: "all 1s ease",
    },
  },
  root: {
    background: "#fff",
    width: "calc(100% - 60px)",
    left: 0,
    maxWidth: "1410px",
    margin: "0 auto",
    [down("xs")]: {
      width: "100%",
      padding: "15px",
    },
  },
  navbarElement: {
    width: "20%",
    [down("sm")]: {
      width: "auto",
    },
  },
  callToAction: {
    flexDirection: "column-reverse",
    "& div": {
      marginRight: 0,
      alignItems: "center",
    },
  },
  telLink: {
    display: "flex",
    paddingBottom: "0 !important",
    marginTop: "15px",
    "& div": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: white,
      padding: "15px 30px",
      borderRadius: "50px",
      "& p": {
        color: blue,
        "@media (max-width: 350px)": {
          fontSize: "12px",
        },
      },
      "@media (max-width: 350px)": {
        padding: "10px 15px",
      },
    },
  },
  mobileOperator: {
    width: "100%",
    // marginTop: "40px",
    position: "absolute",
    left: 0,
    bottom: "20px",
    "@media (max-width: 350px)": {
      bottom: "10px",
    },
  },
}));

export default useStyles;
